import { IFeature } from '@kurtosys/types/app/IFeature.js';

export const Feature: IFeature = {
	useResponsiveComponentConfiguration: true,
	// TODO: Requires debouncing for the Grid app to not timeout the app renders while the grid app is not in view.
	useIntersectionObserver: true,
};
